import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import NarrativeExplorer from './pages/narrative-explorer';
import PlatformBridgeInterface from './pages/platform-bridge-interface';
import CrisisResponseCenter from './pages/crisis-response-center';
import ExpertConsoleDashboard from './pages/expert-console-dashboard';
import FactCheckWorkbench from './pages/fact-check-workbench';
import ClaimDetailAnalysis from './pages/claim-detail-analysis';
import PublicClaimSearch from './pages/public-claim-search';
import ResearchDataPortal from './pages/research-data-portal';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<ClaimDetailAnalysis />} />
        <Route path="/narrative-explorer" element={<NarrativeExplorer />} />
        <Route path="/platform-bridge-interface" element={<PlatformBridgeInterface />} />
        <Route path="/crisis-response-center" element={<CrisisResponseCenter />} />
        <Route path="/expert-console-dashboard" element={<ExpertConsoleDashboard />} />
        <Route path="/fact-check-workbench" element={<FactCheckWorkbench />} />
        <Route path="/claim-detail-analysis" element={<ClaimDetailAnalysis />} />
        <Route path="/public-claim-search" element={<PublicClaimSearch />} />
        <Route path="/research-data-portal" element={<ResearchDataPortal />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
